<template>
    <div class="rating">
        <common-icon class="rating__icon" name="star" size="tiny-small"></common-icon>

        {{ value.toFixed(1) }}
    </div>
</template>

<script>
    export default {
        props: {
            value: { type: Number, required: true },
        },
    }
</script>
